import { Button, Input, InputType, InputOptionBox } from '../../../../core/components/Index';
import { observer } from 'mobx-react';
import ApplyViewModel from './ApplyViewModel';
import { useParams } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import { Steps } from './ApplyModels';
import { Appl } from '../../../../core/Appl';

const DirectDepositAuthorization = observer(() => {
  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');
  let { memberId } = useParams();

  useAsyncEffect(async () => {
    await vm.loadStepAsync(Steps.DirectDepositAuthorization, memberId!);
  }, []);


  return (
    <div className="space-y-8 max-w-4xl">
      {/* Page Header */}
      <div>
        <h1 className="text-32px tracking--1percent text-neutral-800 font-semibold mb-4">Direct Deposit Authorization</h1>
        <p className="text-black text-15px tracking--1percent leading-26px">
          To ensure that your retirement benefits are deposited directly into your bank account, please provide your direct deposit information below.
        </p>
      </div>

      {/* Section: Account Information */}
      <div>
        <h2 className="text-22px tracking--1percent text-black font-semibold mb-4">Account Information</h2>

        <div className="grid grid-cols-2 gap-6 max-w-full">
          {/* Institution Name */}
          <div className="col-span-2">
            <Input
              id="institutionName"
              value={vm.model.directDeposit.institutionName}
              inputType={InputType.Text}
              label="Institution Name"
              onChange={(e) => vm.onInputChange(e, 'institutionName', vm.model.directDeposit)}
              maxLength={100}
            />
          </div>

          {/* Name of Account Holder */}
          <div className="col-span-2">
            <Input
              id="accountHolderName"
              value={vm.model.directDeposit.accountHolderName}
              inputType={InputType.Text}
              label="Name of Account Holder"
              onChange={(e) => vm.onInputChange(e, 'accountHolderName', vm.model.directDeposit)}
              maxLength={100}
            />
          </div>

          {/* Type of Depositor Account */}
          <div className="col-span-2">
            <p className="font-bold text-15px text-black mb-1 block">Type of Depositor Account</p>
            <div className="space-y-2">
              {vm.model.typeOfDepositListItems?.map((item, index) => (
                <div key={`lovAccountTypeId-${index}`} className="flex items-center">
                  <InputOptionBox
                    inputId={`lovAccountTypeId-${item.key}`}
                    label={item.value}
                    value={item.key}
                    checked={vm.model.directDeposit.lovAccountTypeId?.toString() === item.key.toString()}
                    onChange={(e: any) => vm.onInputChange(e, 'lovAccountTypeId', vm.model.directDeposit)}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Nine-Digit Routing Number */}
          <div className='col-span-2 md:col-span-1'>
            <Input
              id="bankRoutingNumeric"
              value={vm.model.directDeposit.bankRoutingNumeric}
              inputType={InputType.Text}
              label="Nine-Digit Routing Number"
              onChange={(e) => vm.onInputChange(e, 'bankRoutingNumeric', vm.model.directDeposit)}
              maxLength={9}
            />
          </div>
          <div  className='hidden md:block'/>
          {/* Account Number */}
          <div className='col-span-2 md:col-span-1'>
            <Input
              id="bankAccountNumeric"
              value={vm.model.directDeposit.bankAccountNumeric}
              inputType={InputType.Text}
              label="Account Number"
              onChange={(e) => vm.onInputChange(e, 'bankAccountNumeric', vm.model.directDeposit)}
              maxLength={50}
            />
          </div>

          {/* Confirm Account Number */}
          <div className='col-span-2 md:col-span-1'>
            <Input
              id="confirmbankAccountNumeric"
              value={vm.model.directDeposit.confirmbankAccountNumeric}
              inputType={InputType.Text}
              label="Confirm Account Number"
              onChange={(e) => vm.onInputChange(e, 'confirmbankAccountNumeric', vm.model.directDeposit)}
              maxLength={50}
            />
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex mt-6 flex-wrap gap-2 sm:flex-nowrap">
        <Button
          onClick={async () => await vm.onDirectDepositAccountInfoStepChangeAsync()}
          label="Save & Continue" rounded
          disabled={!(vm.model.directDeposit.institutionName !== ""
            && vm.model.directDeposit.accountHolderName !== ""
            && vm.model.directDeposit.lovAccountTypeId! > 0
            && vm.model.directDeposit.bankRoutingNumeric !== ""
            && vm.model.directDeposit.bankAccountNumeric != ""
            && vm.model.directDeposit.confirmbankAccountNumeric != ""
          )}
        />
        {vm.navigatedFromReviewScreen && <Button title="Cancel & Return to Review" severity='secondary' rounded
          onClick={async () => await vm.navigateToReviewStepAsync()}
        />}
      </div>
    </div>
  );
});

export default DirectDepositAuthorization;
